import React, { useState, useEffect } from 'react';
import {
    Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Button, Dialog, DialogActions, TextField,
    Typography
} from '@mui/material';
import axiosInstance from '../utills/axiosInstance';
import { usePermissions } from '../utills/usePermissions';

const LeaveApproval = () => {
    const [requests, setRequests] = useState([]);
    const [openDialog, setOpenDialog] = useState(false);
    const [selectedRequest, setSelectedRequest] = useState(null);
    const [comments, setComments] = useState('');

    const { canApprove, canReject } = usePermissions();

    useEffect(() => {
        fetchApprovals();
    }, []);

    const fetchApprovals = async () => {
        try {
            const res = await axiosInstance.get(`/api/leave/approvals`);
            setRequests(res.data);
        } catch (err) {
            console.error(err);
        }
    };

    const handleAction = async (action) => {
        try {
            const endpoint = action === 'approve' ? '/approve' : '/reject';
            await axiosInstance.patch(`/api/leave/requests/${selectedRequest._id}${endpoint}`, { comments });
            setOpenDialog(false);
            fetchApprovals();
        } catch (err) {
            console.error(err);
        }
    };

    const formatDateRange = (fromDate, toDate) => {
        const from = new Date(fromDate).toLocaleDateString();
        const to = new Date(toDate).toLocaleDateString();
        return from === to ? from : `${from} - ${to}`;
    };

    return (
        <Paper sx={{ p: 2, m: 1 }}>
            <Typography variant="h5" textAlign="center" mb={4}>
                All Leave Requests
            </Typography>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Employee</TableCell>
                            <TableCell>Type</TableCell>
                            <TableCell>From-To</TableCell>
                            <TableCell>Duration</TableCell>
                            <TableCell>Reason</TableCell>
                            <TableCell>Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {requests.filter(req => req.status === 'Pending').map((req) => (
                            <TableRow key={req._id}>
                                <TableCell>{req.employee.firstName} {req.employee.lastName}</TableCell>
                                <TableCell>{req.leaveType.name}</TableCell>
                                <TableCell>{formatDateRange(req.fromDate, req.toDate)}</TableCell>
                                <TableCell>{req.duration}</TableCell>
                                <TableCell>{req.reason}</TableCell>
                                <TableCell>
                                    {
                                        (canApprove('leave') || canReject('leave')) && (
                                            <Button onClick={() => { setSelectedRequest(req); setOpenDialog(true); }}>Review</Button>
                                        )
                                    }
                                    {
                                        !canApprove('leave') && !canReject('leave') && (
                                            <Typography>No Permission for approvals</Typography>
                                        )
                                    }
                            </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
                <DialogActions>
                    <TextField
                        label="Comments"
                        value={comments}
                        onChange={(e) => setComments(e.target.value)}
                        fullWidth
                        multiline
                        rows={3}
                    />
                    {
                        canReject('leave') && (
                            <Button onClick={() => handleAction('reject')}>Reject</Button>
                        )
                    }
                    {
                        canApprove('leave') && (
                            <Button onClick={() => handleAction('approve')} variant="contained">Approve</Button>
                        )
                    }
                </DialogActions>
            </Dialog>
        </Paper>
    );
};

export default LeaveApproval;
